<template>
  <div>
    <div class="row no-margin">
      <div class="col no-padding">
        <h2 class="sub-title">INVOICE</h2>
        <div class="summary-panel pdfnone">
          <div class="panel-grid">
            <ul class="panel-grid-list">
              <li>
                <div class="panel-grid-list-header">INVOICE NO</div>
                <!-- <div class="panel-grid-list-text">IN890067B</div> -->
                <div class="plstyle" v-if="hideEdits">
                  <input
                    class="text-inputvalue"
                    type="text"
                    placeholder="Invoice No"
                    @input="updateInvoice"
                  >
                </div>
                <div class="plstyle"  v-else>
                  <div class="panel-grid-list-text">{{$store.invoice.invoice_number}}</div>
                </div>
              </li>
            </ul>
          </div>
        </div>


        <div class="bottomfixed pdfnone">
            <h2 class="sub-title">E- SIGNATURE</h2>
          <div class="signature-field">
            <div class="sigbox">
            </div>
          </div>
        </div>

      </div>

      <div class="col-5 bg-sign">
        <div class="signature-totalcontent">
          <div class="row content-list lh">
            <div class="col-4 content-list-title no-padding">Total</div>
            <div class="col content-list-total">{{Number(acutal_total).toFixed(2)}}</div>
          </div>

          <div class="row content-list lh" v-for="(remits, index) in remits" :key="index">
            <div class="col-4 content-list-title no-padding">{{remits.label}} </div>
            <div class="col content-list-label">{{remits.percentage}} %</div>
            <div class="col content-list-total">{{Number(remits.amount).toFixed(2)}}</div>
          </div>
          <!-- <div class="row content-list lh">
      <div class="col-4 content-list-title">Wallet</div>
      <div class="col-5 content-list-label mrg10">

      <Popover placement="bottom-end" v-model="penalties" popper-class="newpopover tablepadding">
        <div class="popover-primary">
          <div class="popover-primary-header">
            <h3>PENALTIES</h3>
            <span class="remove-icon" @click="penalties=false">
              <svgicon name="cancelblack" width="12" height="12" :original="true" />
            </span>
          </div>
          <div class="popover-primary-body">
        <penalty />
          </div>
        </div>
        <div slot="reference">
          <div class="nmrg10">
          2 penalties applied
          <div class="notificationicon">
          <svgicon name="info-blue" width="12" height="12" :original="true" />
        </div>
      </div>
        </div>
      </Popover>
      </div>
      <div class="col content-list-total">0</div>
          </div>-->

          <div
            class="row content-list lh"
            v-if="$hasFeature('transporter_payment_discount') && discount"
          >
            <div class="col-4 content-list-title no-padding">Discount</div>
            <div class="col-5 content-list-label">{{discount}} %</div>
            <div class="col content-list-total">{{Number(discountAmount).toFixed(2)}}</div>
          </div>

          <Wallet v-if="this.hideEdits && !isLoading && walletList && walletList.length"  :total="walletTotal" :wallets="walletList"/>
          <Wallet v-if="!this.hideEdits && appliedWallet && appliedWallet.length" :total="walletTotal" :wallets="appliedWallet" />

          <div class="row content-list lh" v-if="remits.length">
            <div class="col-4 content-list-title no-padding">Sub Total</div>
            <div class="col-5 content-list-label"></div>
            <div class="col content-list-total">{{Number(subTotal).toFixed(2)}}</div>
          </div>

          <div class="row content-list">
            <div class="col-4 content-list-title no-padding">Service recepient state</div>
            <div class="col-5 content-list-label">
              <div class="dropdown-section">{{serviceReciepentState}}</div>
            </div>
          </div>
          <div class="row content-list">
            <div class="col-4 content-list-title no-padding">Service Provider state</div>
            <div class="col-6 content-list-label">
              <div class="dropdown-section mrgn10"  v-if="hideEdits">
                <Select
                  v-if="hideEdits"
                  :value="selectedState"
                  value-key="name"
                  @change="stateSelected"
                  placeholder="Select"
                >
                  <Option v-for="item in options" :key="item.name" :label="item.name" :value="item"></Option>
                </Select>
              </div>
              <div v-else>
                {{$store.invoice.tax.destination}}
              </div>
            </div>
          </div>
          <div class="row content-list">
            <div class="col-4 content-list-title no-padding">GST Method</div>
            <div class="col-6 content-list-label">
              <div class="dropdown-section" v-if="hideEdits">
                <Radio v-model="paid_to" v-if="!ispaidtoExist" @change="forwardReverseChange" label="1">Forward</Radio>
                <Radio v-model="paid_to" v-if="!ispaidtoExist" @change="forwardReverseChange" label="2">Reverse</Radio>
                <div v-if="ispaidtoExist">{{(paid_to == '1') ? 'Forward' : 'Reverse'}}</div>
                <div class="mrgn10" v-if="currentClientConfig.is_gst_master_priority && isFCM">
                   {{currentTransporterGST.percentage}}
                </div>
                <div v-else>
                <Select
                  v-if="isFCM && hideEdits"
                  :value="selectedPercentage"
                  value-key="name"
                  @change="percentageSelected"
                  placeholder="Select"
                >
                  <Option
                    v-for="item in fcmGstList"
                    :key="item.name"
                    :label="item.name"
                    :value="item"
                  ></Option>
                </Select>
              </div>
              </div>
              <div v-else>{{(paid_to == '1') ? 'Forward' : 'Reverse'}}</div>
            </div>
          </div>
          <div class="row content-list">
            <div class="col-4 content-list-title no-padding">GSTIN</div>
            <div class="col content-list-label" v-if="hideEdits">
              <input
                v-if="!gstinList.length"
                class="input"
                type="text"
                placeholder="Enter GSTN"
                :value="gstno"
                @input="updateGstNo"
              >
              <span v-else>{{gstno}}</span>
            </div>
            <div class="col content-list-label" v-else>
              {{$store.invoice.gst_number}}
            </div>
          </div>
          <div class="row content-list lh hr" v-if="isFCM">
            <div class="col-4 content-list-title no-padding">Tax</div>
            <div class="col content-list-label" v-if="isSameState">
              <div class="col-8 colfloat">
              <div class="lhn">CGST {{central_tax}}% {{Number(total_central_tax).toFixed(2)}}</div>
              <div class="lhn">SGST {{state_tax}}% {{Number(total_state_tax).toFixed(2)}}</div>
              </div>
            <div class="col-4 colfloat content-list-total"  v-if="isSameState">{{Number((total_state_tax + total_central_tax)).toFixed(2)}}</div>
            </div>


            <div class="col content-list-label" v-if="!isSameState">
              <div class="col-8 colfloat no-paading">
              <div class="lhn">IGST {{igst_tax}}% {{Number(total_igst_tax).toFixed(2)}}</div>
              </div>
             <div class="col-4 colfloat content-list-total"> {{Number(total_igst_tax).toFixed(2)}}</div>
            </div>
          </div>
          <div class="row content-list lh hr" v-else></div>
          <div class="row content-list" v-if="isApproved">
            <div class="col-4 content-list-title no-padding">Payable</div>
            <div class="col content-list-total primary">{{Number(approvedAmount).toFixed(2)}}</div>
          </div>
          <div class="row content-list" v-if="!isApproved">
            <div class="col-4 content-list-title no-padding">Requested</div>

            <div class="col content-list-total">{{Number(totalAmount).toFixed(2)}}</div>
          </div>
          <div class="row content-list" v-if="!hideEdits && canShowNote">
            <div class="col-4 content-list-title">{{noteLabel}}</div>
            <div class="col content-list-notes">
              <!-- Debit note number will show here
              after approval-->
            </div>
            <div class="col content-list-total error">{{noteAmount}} INR</div>
          </div>
        </div>
      </div>
      <div class="bottomfixed webnone">
    Note: This is an electronic invoice issued in accordance with the provisions of the Information Technology Act, 2000 (21 of 2000).
    Hence, does not require any signature or digital signature
   </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import { mapGetters } from "vuex";
import states from "@/constants/india-states";
import PaymentRemits from "@/lib/payment-remits";
import Wallet from './wallet/index';
import { log } from 'util';

export default {
  components:{
    Wallet
  },

  props: ['depot', 'gstinList'],

  data() {
    const payment = this.$store.payments.selected[0];
    const {
      igst_tax: igstTax,
      paid_to: paidTo,
      state_tax: stateTax,
      central_tax: centralTax
    } = this.$store.payments;

    const { tax: taxObj, gst_type } = this.$store.invoice && this.$store.invoice ?  this.$store.invoice: {  }

    const sourcestate = payment.destination_state;
    const selectedState = states.find(state => state.name === sourcestate);
    this.$store.payments.selectedState = selectedState;
    const paid_to = `${paidTo}`;
    return {
      wallet: [
        {order: 'PL-BN-102', amount: 10, type: 1, reason: 'SLA Breach' },
        //{order: 'PL-BN-103', amount: 20, type: 2, reason: 'SLA Breach'},
        {order: 'PL-BN-103', amount: 20, type: 2, reason: 'SLA Breach'},

      ],
      activeNames: ["1"],
      paid_to,
      isForwardOneWay: paid_to === "1",
      options: states,
      selectedState,
      ispaidtoExist: Boolean(paid_to),
      igst_tax: igstTax,
      acutal_total: 0,
      state_tax: stateTax,
      central_tax: centralTax,
      isSameState: (taxObj) ? taxObj.same_state === 1 ? true : false : '', //TODO Need to change to pando constanct page
      total_state_tax: 0,
      total_central_tax: 0,
      total_amount: 0,
      total_igst_tax: 0,
      remits: [],
      discount: 0,
      discountAmount: 0,
      subTotal: 0,
      gstno: this.$store.payments.gstno,
      forward_changed: false,
      invoiceno: "",
      seen: false
    };
  },
  computed: {
    fcmGstList() {
      return this.transporterNonGst.igst_tax.map(gst => {
        return {
          name: gst
        };
      });
    },
    orderCount() {
      return this.$store.payments && this.$store.payments.selected
        ? this.$store.payments.selected.length
        : 0;
    },
    // gstno() {
    //   const transporter = this.currentTransporter;
    //   const transporterGst = transporter.gst_details.find(
    //     gst => gst.client_id === this.currentClient.id
    //   );
    //   this.$store.payments.gstno = transporterGst ? transporterGst.number : "";
    //   return this.$store.payments.gstno;
    // },
    currentTransporterGST() {
      const transporter = this.currentTransporter;
      return transporter.gst_details.find(
        gst => gst.client_id === this.currentClient.id
      );
    },
    ...mapGetters({
      currentTransporter: "app/currentTransporter",
      currentClient: "app/currentClient",
      transporterNonGst: "app/transporterNonGst",
      currentClientConfig: "app/currentClientConfig",
      walletList: "wallet/list",
      isLoading: "wallet/isLoading"
    }),
    appliedWallet() {
      return this.$store.invoice && this.$store.invoice.wallet_ids;
    },

    walletTotal() {
      let totalWallet = 0;
      if(this.hideEdits) {
        totalWallet = this.walletList.reduce((total, wal) => total + wal.amount, 0);
      } else {
        totalWallet = this.appliedWallet.reduce((total, wal) => total + wal.amount, 0);
      }
      return totalWallet;
    },

    serviceReciepentState() {
      let state =
        this.$store.payments &&
        this.$store.payments.selected &&
        this.$store.payments.selected.length > 0
          ? this.$store.payments.selected[0].depot.state
          : "";
      this.$store.payments.sourcestate = state;
      return state;
    },
    showNote() {
      return this.$store.showNote;
    },
    noteAmount() {
      return this.$store.invoice.revision && this.$store.invoice.revision.value
        ? this.$store.invoice.revision.value
        : 0;
    },
    isApproved() {
      let approved = false;
      if (this.$store.invoice && this.$store.invoice.status) {
        approved = this.$store.invoice.status >= 3;
      }
      return approved;
    },
    selectedPercentage() {
      return this.igst_tax;
    },
    totalAmount() {
      if (this.$store.showInvoice) {
        const { igst, sgst, cgst } = this.$store.invoice.tax;
        this.igst_tax = igst;
        this.paid_to = this.$store.invoice.gst_type;
        this.state_tax = sgst;
        this.central_tax = cgst;
      }

      let amount = this.showNote
        ? this.$store.invoice.revision.value
        : this.$store.payments.transporter_total;
      this.acutal_total = amount;
      const { remits, total_amount: totalAmount } = this.paymentRemits(amount);
      this.remits = remits;
      amount = totalAmount;
      const isForward = `${this.paid_to}` === "1";
      if (
        this.$hasFeature("transporter_payment_discount") &&
        this.currentTransporterGST.payment_discount
      ) {
        if (!this.$store.showInvoice) {
          this.discount = this.currentTransporterGST.payment_discount;
          this.discountAmount =
            amount * (this.currentTransporterGST.payment_discount / 100);
          amount = amount - this.discountAmount;
        }
      }

      // if (this.hideEdits && !this.isLoading && this.walletList.length) {
      //   amount = amount - this.walletTotal;
      // }

      //  if (!this.hideEdits) {
      //   amount = amount - this.walletTotal;
      // }

       this.subTotal = amount;
      if (this.isSameState) {
        this.total_state_tax = amount * (this.state_tax / 100);
        this.total_central_tax = amount * (this.central_tax / 100);
        this.total_amount = isForward
          ? this.total_state_tax + this.total_central_tax + amount
          : amount;
      } else {
        this.total_igst_tax = amount * (this.igst_tax / 100);
        this.total_amount = isForward ? this.total_igst_tax + amount : amount;
      }
      return this.total_amount;
    },
    approvedAmount() {
      if (this.$store.showInvoice) {
        const { igst, sgst, cgst } = this.$store.invoice.tax;
        this.igst_tax = igst;
        this.paid_to = this.$store.invoice.gst_type;
        this.state_tax = sgst;
        this.central_tax = cgst;
      }
      if (this.$store.showInvoice) {
        this.discount = 0;
      }
      let amount = this.showNote
        ? this.$store.invoice.revision.value
        : this.$store.payments.client_total;
      this.acutal_total = amount;
      const { remits, total_amount: totalAmount } = this.paymentRemits(amount);
      this.remits = remits;
      amount = totalAmount;
      const isForward = `${this.paid_to}` === "1";

      this.subTotal = amount;
      if (this.isSameState) {
        this.total_state_tax = amount * (this.state_tax / 100);
        this.total_central_tax = amount * (this.central_tax / 100);
        this.total_amount = isForward
          ? this.total_state_tax + this.total_central_tax + amount
          : amount;
      } else {
        this.total_igst_tax = amount * (this.igst_tax / 100);
        this.total_amount = isForward ? this.total_igst_tax + amount : amount;
      }
      return this.total_amount;
    },
    isFCM() {
      return `${this.paid_to}` === "1";
    },
    hideEdits() {
      return !this.$store.showInvoice;
    },
    canShowNote() {
      return (
        this.$store.invoice &&
        this.$store.invoice.revision &&
        this.$store.invoice.revision.number
      );
    },
    noteLabel() {
      return this.$store.invoice.revision.type === 1
        ? "Credit Note Number"
        : "Debit Note Number";
    },
    noteValue() {
      return this.$store.invoice.revision.number;
    }
  },

 async created() {
    if (this.hideEdits) {
      const indentIds = this.$store.payments.selected.map(
        payment => payment.order.order_id
      );
      const wallet = await this.$store.dispatch("wallet/getAll", {
        depotId: this.depot.id,
        indentIds
      });
      this.$store.payments.wallet_ids = wallet;
    } else {
        this.$emit('gstinNumberUpdate', this.$store.invoice.gst_number);
    }
    if(this.gstinList.length){
      this.options = this.gstinList.map(branch => { return {code: branch.id, name: branch.state }});
      if(this.gstinList.length === 1){
        this.stateSelected(this.options[0]);
      }
    }

  },

  watch: {},
  methods: {
    updateInvoice(data) {
      const { target } = data;
      this.invoiceno = target.value;
      this.$store.payments.invoiceno = target.value;
    },
    updateGstNo(data) {
      const { target } = data;
      this.$store.payments.gstno = target.value;
    },
    paymentRemits(amount) {
      let invoiceFields = [];
      if (this.$store.showInvoice) {
        invoiceFields = this.$store.invoice && this.$store.invoice.additional_charges ? this.$store.invoice.additional_charges : [];
      } else {
        invoiceFields = this.currentClientConfig.invoice_fields
        ? this.currentClientConfig.invoice_fields
        : [];
      }
      return PaymentRemits(invoiceFields, amount);
    },
    forwardReverseChange() {
      const payment = this.currentTransporterGST;
      const isForward = this.paid_to === "1";
      this.$emit("paidtochanged", this.paid_to);
      if (isForward) {
        if (payment.paid_to === 2) {
          this.igst_tax = this.transporterNonGst.igst_tax[0];
          this.state_tax = this.transporterNonGst.igst_tax[0] / 2;
          this.central_tax = this.transporterNonGst.igst_tax[0] / 2;
          this.forward_changed = false;
        } else {
          this.igst_tax = payment.percentage;
          this.state_tax = payment.percentage / 2;
          this.central_tax = payment.percentage / 2;
          this.forward_changed = false;
        }
      } else {
        this.state_tax = 2.5;
        this.central_tax = 2.5;
        this.igst_tax = 5;
        this.forward_changed = true;
      }
      this.$store.payments.igst_tax = this.igst_tax;
      this.$store.payments.paid_to = this.paid_to;
    },
    stateSelected(selectedState) {
      this.selectedState = selectedState;
      const { gst_number } = this.currentTransporter;
      const isExist = gst_number.find((gst) => gst.state === selectedState.name);
      if(isExist) {
        this.gstno = isExist.number;
        this.$store.payments.gstno = isExist.number;
        this.$store.payments.gstno_ref_id = isExist.ref_id || '';
      } else {
        this.gstno = '';
        this.$store.payments.gstno = '';
        this.$store.payments.gstno_ref_id = '';
      }
      this.$emit('gstinNumberUpdate', this.gstno );
      this.isSameState = this.serviceReciepentState.replace(/\s+/g, '').toLowerCase() ===
          selectedState.name.replace(/\s+/g, '').toLowerCase();
      this.$store.payments.selectedState = selectedState;
    },
    percentageSelected(gstPercentage) {
      const selected = gstPercentage.name;
      this.state_tax = selected / 2;
      this.central_tax = selected / 2;
      this.igst_tax = selected;
      this.$store.payments.igst_tax = selected;
    },
    calculateTotal() {
      const payments = this.$store.payments.selected;
      let totalTax = 0;
      const isIgst = payments[0].transporter.same_state === 1;
      const isVendorTaxPay = payments[0].transporter.paid_to === 1;
      payments.forEach(payment => {
        const tax = isVendorTaxPay
          ? payment.transporter.service_charge
          : payment.transporter.no_tax;
        totalTax += Number(tax);
      });
      this.total_amount = isVendorTaxPay
        ? this.$store.payments.total_amount + totalTax
        : this.$store.payments.total_amount;
    }
  }
};
</script>

<style lang='scss'>
.webnone{
  display:none;
}
.colfloat{
  display: inline-block;
  float: left;
  padding: 0px;
}
</style>
